'use client'

import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useProductAddToCartQuantitySelectionDiscountBadgeData } from './useProductAddToCartQuantitySelectionDiscountBadgeData'

export const ProductVolumePricingExtendedDiscountBadge: FC<{
  className?: string
  selectedValue: number
}> = ({ className, selectedValue }) => {
  const { discount } =
    useProductAddToCartQuantitySelectionDiscountBadgeData(selectedValue)

  if (discount && discount > 0) {
    return (
      <div
        className={clsx(
          'flex w-fit flex-nowrap items-center justify-center gap-1 rounded-full bg-light-tertiary p-2 text-xs font-medium text-dark-primary-max tablet:hidden',
          className,
        )}
      >
        <FormattedMessage
          id="volumePricing.quantity.percentage.saving"
          values={{ discount }}
        />
      </div>
    )
  }

  return null
}
